/*****************************************************************************************************************************************************
 * Revision History
 * 2025-03-03 TBH - Created resetValidators() method to clear validators, removed redundant lines of code doing same in updateAddressData() (halved #lines!)
 * 2025-03-04 TBH - Removed "U.S.A." from list of selectable countries for international address.
 * 2025-03-04 TBH - Province optional on Business address if country is not "U.S.A."
 * 2025-03-05 TBH - Require Business address line 1.
 *****************************************************************************************************************************************************/
export default function updateAddress() {
// console.log( 'updateAddress' );
  return {
    localAddressCountry: [],
    businessAddressCountry: [],
    permanentAddressCountry: [],
    addresses: {
      localAddress: { address1: '', address2: '', address3: '', city: '', state: '', country: 'U.S.A.', province: '', company: '', isPreferredAddress: false, zipCode: '', addressType: 1 },
      businessAddress: { address1: '', address2: '', address3: '', city: '', state: '', country: '', province: '', company: '', isPreferredAddress: false, zipCode:'', addressType:2},
      permanentAddress: { address1: '', address2: '', address3: '', city: '', state: '', country: '', province: '', company: '', isPreferredAddress: false, zipCode: '', addressType: 3 },
    },
    emailAddress: '',
    isLocalSubmitted: false,
    isBusinessSubmitted: false,
    isPermanentSubmitted: false,
    zotAlertChecked: false,

    localAddressResponse: '',
    businessAddressResponse: '',
    permanentAddressResponse: '',

    passedLocalAddress1: '',
    passedLocalAddress2: '',
    passedLocalAddress3: '',
    passedLocalCity: '',
    passedLocalState: '',
    passedLocalCountry: '',
    passedLocalIsPreferredAddress: '',
    passedLocalZipCode: '',

    passedBusinessCompany: '',
    passedBusinessAddress1: '',
    passedBusinessAddress2: '',
    passedBusinessCity: '',
    passedBusinessState: '',
    passedBusinessCountry:'',
    passedBusinessProvince: '',
    passedBusinessPosition: '',
    passedBusinessIsPreferredAddress: '',
    passedBusinessZipCode: '',

    passedPermanentAddress1: '',
    passedPermanentAddress2: '',
    passedPermanentAddress3: '',
    passedPermanentCity: '',
    passedPermanentState: '',
    passedPermanentCountry: '',
    passedPermanentProvince: '',
    passedPermanentCompany: '',
    passedPermanentPosition: '',
    passedPermanentIsPreferredAddress: '',
    passedPermanentZipCode: '',

    isBusinessAddress1: true,
    isBusinessAddress2: true,
    isBusinessAddress3: true,
    isBusinessCity: true,
    isBusinessState: true,
    isBusinessCountry: true,
    isBusinessProvince: true,
    isBusinessCompany: true,
    isBusinessPosition: true,
    isBusinessIsPreferredAddress: true,
    isBusinessZipCode: true,

    isLocalAddress1: true,
    isLocalAddress2: true,
    isLocalAddress3: true,
    isLocalCity: true,
    isLocalState: true,
    isLocalCountry: true,
    isLocalProvince: true,
    isLocalCompany: true,
    isLocalPosition: true,
    isLocalIsPreferredAddress: true,
    isLocalZipCode: true,

    isPermanentAddress1: true,
    isPermanentAddress2: true,
    isPermanentAddress3: true,
    isPermanentCity: true,
    isPermanentState: true,
    isPermanentCountry: true,
    isPermanentProvince: true,
    isPermanentCompany: true,
    isPermanentPosition: true,
    isPermanentIsPreferredAddress: true,
    isPermanentZipCode: true,

    isBusinessAddress1Error: '',
    isBusinessAddress2Error: '',
    isBusinessAddress3Error: '',
    isBusinessCityError: '',
    isBusinessStateError: '',
    isBusinessCountryError: '',
    isBusinessProvinceError: '',
    isBusinessCompanyError: '',
    isBusinessPositionError: '',
    isBusinessIsPreferredAddressError: '',
    isBusinessZipCodeError: '',

    isLocalAddress1Error: '',
    isLocalAddress2Error: '',
    isLocalAddress3Error: '',
    isLocalCityError: '',
    isLocalStateError: '',
    isLocalCountryError: '',
    isLocalProvinceError: '',
    isLocalPositionError: '',
    isLocalIsPreferredAddressError: '',
    isLocalZipCodeError: '',

    isPermanentAddress1Error: '',
    isPermanentAddress2Error: '',
    isPermanentAddress3Error: '',
    isPermanentCityError: '',
    isPermanentStateError: '',
    isPermanentCountryError: '',
    isPermanentProvinceError: '',
    isPermanentIsPreferredAddressError: '',
    isPermanentZipCodeError: '',

    message: '',
    isMessage:true,                         // Info message if true, otherwise error message.
    isSubmitting: false,
    permanentAddressStates: [],
    businessAddressStates: [],
    localAddressStates:[],

    fetchCountry() {
      fetch(' /api/common/GetCountry').then(( response ) => {
        if( response.ok ) {
          return response.json()
        }
      }).then(( addressCountry ) => {
// console.log( 'fetchCountry(): ' + JSON.stringify( addressCountry ));
        this.localAddressCountry = addressCountry;
        this.businessAddressCountry = addressCountry;
        this.permanentAddressCountry = addressCountry.filter( c => c.value != "U.S.A." );
        this.bindAddresses();
      }).catch(( error ) => {
        console.error( error );
      });
    },

    businessCountryChange() {
      if (this.addresses.businessAddress.country == 'U.S.A.') {
        this.addresses.businessAddress.province = "";
      } else {
        this.addresses.businessAddress.state = "";
      }
    },

    bindAddresses() {
// console.log( 'bindAddresses()' );
      fetch('/api/UserAPI/GetProfile', { "method": "GET" }).then(response => {
        if (response.ok) {
          return response.json()
        }
      }).then( response => {
// console.log( 'bindAddresses() response: ' + JSON.stringify( response ));
        if( response != undefined && response.isSuccess ) {
          this.showErrorMesage = "";
          this.businessAddressResponse = response.businessAddress;
          this.localAddressResponse = response.localAddress;
          this.permanentAddressResponse = response.permanentAddress;
                      
          this.addresses.localAddress.address1 = this.localAddressResponse.address1 == null ? "" : this.localAddressResponse.address1;
          this.addresses.localAddress.address2 = this.localAddressResponse.address2 == null ? "" : this.localAddressResponse.address2;
          this.addresses.localAddress.address3 = this.localAddressResponse.address3 == null ? "" : this.localAddressResponse.address3;
          this.addresses.localAddress.city = this.localAddressResponse.city == null ? "" : this.localAddressResponse.city;
          this.addresses.localAddress.state = this.localAddressResponse.state == null ? "" : this.localAddressResponse.state;
                        
          this.addresses.localAddress.addressType = this.localAddressResponse.addressType == null ? false : this.localAddressResponse.addressType;
          this.addresses.localAddress.zipCode = this.localAddressResponse.zipCode == null ? "" : this.localAddressResponse.zipCode;
          if( response.people.preferredAddressType == 1 ) {
            this.addresses.localAddress.isPreferredAddress = true;
          }

          this.addresses.businessAddress.address1 = this.businessAddressResponse.address1 == null ? "" : this.businessAddressResponse.address1;
          this.addresses.businessAddress.address2 = this.businessAddressResponse.address2 == null ? "" : this.businessAddressResponse.address2;
          this.addresses.businessAddress.company = this.businessAddressResponse.company == null ? "" : this.businessAddressResponse.company;
          this.addresses.businessAddress.city = this.businessAddressResponse.city == null ? "" : this.businessAddressResponse.city;
          this.addresses.businessAddress.state = this.businessAddressResponse.state == null ? "" : this.businessAddressResponse.state;
          this.addresses.businessAddress.province = this.businessAddressResponse.province == null ? "" : this.businessAddressResponse.province;
          this.addresses.businessAddress.country = this.businessAddressResponse.country == null ? "" : this.businessAddressResponse.country;

          this.addresses.businessAddress.addressType = this.businessAddressResponse.addressType == null ? false : this.businessAddressResponse.addressType;
          this.addresses.businessAddress.zipCode = this.businessAddressResponse.zipCode == null ? "" : this.businessAddressResponse.zipCode;
          if( response.people.preferredAddressType == 2 ) {
            this.addresses.businessAddress.isPreferredAddress = true;
          }

          this.addresses.permanentAddress.address1 = this.permanentAddressResponse.address1 == null ? "" : this.permanentAddressResponse.address1;
          this.addresses.permanentAddress.address2 = this.permanentAddressResponse.address2 == null ? "" : this.permanentAddressResponse.address2;
          this.addresses.permanentAddress.address3 = this.permanentAddressResponse.address3 == null ? "" : this.permanentAddressResponse.address3;
          this.addresses.permanentAddress.city = this.permanentAddressResponse.city == null ? "" : this.permanentAddressResponse.city;
          this.addresses.permanentAddress.province = this.permanentAddressResponse.province == null ? "" : this.permanentAddressResponse.province;
          this.addresses.permanentAddress.country = this.permanentAddressResponse.country == null ? "" : this.permanentAddressResponse.country;

          this.addresses.permanentAddress.addressType = this.permanentAddressResponse.addressType == null ? false : this.permanentAddressResponse.addressType;
          this.addresses.permanentAddress.zipCode = this.permanentAddressResponse.zipCode == null ? "" : this.permanentAddressResponse.zipCode;
          if( response.people.preferredAddressType == 3 ) {
            this.addresses.permanentAddress.isPreferredAddress = true;
          }
        } else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
        }
      });

    },

    resetData() {
// console.log( 'resetData()' );
      this.isMessage = true;
      this.message = "";

      this.passedLocalAddress1 = "";
      this.passedLocalAddress2 = "";
      this.passedLocalAddress3 = "";
      this.passedLocalCity = "";
      this.passedLocalState = "";
      this.passedLocalCountry = "";
      this.passedLocalProvince = "";
      this.passedLocalCompany = "";
      this.passedLocalPosition = "";
      this.passedLocalIsPreferredAddress = "";
      this.passedLocalZipCode = "";

      this.passedBusinessCompany = "";
      this.passedBusinessAddress1 = "";
      this.passedBusinessAddress2 = "";
      this.passedBusinessCity = "";
      this.passedBusinessState = "";
      this.passedBusinessCountry = "";
      this.passedBusinessProvince = "";
      this.passedBusinessPosition = "";
      this.passedBusinessIsPreferredAddress = "";
      this.passedBusinessZipCode = "";

      this.passedPermanentAddress1 = "";
      this.passedPermanentAddress2 = "";
      this.passedPermanentAddress3 = "";
      this.passedPermanentCity = "";
      this.passedPermanentState = "";
      this.passedPermanentCountry = "";
      this.passedPermanentProvince = "";
      this.passedPermanentCompany = "";
      this.passedPermanentPosition = "";
      this.passedPermanentIsPreferredAddress = "";
      this.passedPermanentZipCode = "";
    },

    localClick() {
      this.addresses.localAddress.isPreferredAddress = true;
      this.addresses.businessAddress.isPreferredAddress = false;
      this.addresses.permanentAddress.isPreferredAddress = false;
      this.message = "";
      this.isMessage = true;
    },
    businessClick() {
      this.addresses.localAddress.isPreferredAddress = false;
      this.addresses.businessAddress.isPreferredAddress = true;
      this.addresses.permanentAddress.isPreferredAddress = false;
      this.message = "";
      this.isMessage = true;
    },
    permanentClick() {
      this.addresses.localAddress.isPreferredAddress = false;
      this.addresses.businessAddress.isPreferredAddress = false;
      this.addresses.permanentAddress.isPreferredAddress = true;
      this.message = "";
      this.isMessage = true;
    },

    getStates() {
      fetch( '/api/common/getstates' ).then(( response ) => {
        if( response.ok ) {
          return response.json()
        }
      }).then(( addressStates ) => {
        this.permanentAddressStates = addressStates;
        this.businessAddressStates = addressStates;
        this.localAddressStates = addressStates;
        this.fetchCountry();
      }).catch(( error ) => {
        console.error( error );
      })
    },

    resetValidators() {
// console.log( 'resetValidators()' );
      this.isLocalAddress1Error = "";
      this.isLocalCityError = "";
      this.isLocalStateError = "";
      this.isLocalZipCodeError = "";

      this.isBusinessCompanyError = "";
      this.isBusinessAddress1Error = "";
      this.isBusinessCityError = "";
      this.isBusinessProvinceError = "";
      this.isBusinessStateError = "";
      this.isBusinessCountryError = "";
      this.isBusinessZipCodeError = "";

      this.isPermanentAddress1Error = "";
      this.isPermanentCityError = "";
      this.isPermanentCountryError = "";
      this.isPermanentZipCodeError = "";

      this.message = "";
      this.isSubmitting = true;               // Assume inputs are valid. Set false if address not updated due to one or more invalid inputs.
    },
    saveAddress() {
// console.log( 'saveAddress()' );
      fetch('/api/UserAPI/UpdateAddress', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          LocalAddress: this.addresses.localAddress,
          BusinessAddress: this.addresses.businessAddress,
          InternationalAddress: this.addresses.permanentAddress,
          })
        }).then(response => {
          if( response.ok ) {
            return response.json()
          }
        }).then( response => {
          if( response.isSuccess ) {
            this.message = "Address information updated successfully.";
            this.isMessage = true;
          } else {
          this.message = "Something went wrong";
          this.isMessage = false;
        }
      });
// console.log( 'saveAddress() - End: ' + this.message );
    },
    updateAddressData() {
// console.log( 'updateAddressData()' );
      this.isSubmitting = true;

      this.resetValidators();

      if( !this.addresses.localAddress.isPreferredAddress 
          && !this.addresses.businessAddress.isPreferredAddress 
          && !this.addresses.permanentAddress.isPreferredAddress ) {
        this.message = "At least one primary address should be selected." // This sufficient for !People.PreferredAddressComplete?
        this.isMessage = false;
// console.log( this.message );
      } else if( this.addresses.localAddress.isPreferredAddress ) {
/* Alternate validator coding:
        this.isLocalAddress1 = this.addresses.localAddress.address1.length > 0;
        if( !this.isLocalAddress1 ) {
          this.isLocalAddress1Error = "Please enter Street Address";
        }
 */
        if( this.addresses.localAddress.address1 == "" ) {
          this.isLocalAddress1Error = "Please enter Street Address";
          this.isLocalAddress1 = false;
        } else {
          this.isLocalAddress1 = true;
        }
        if( this.addresses.localAddress.city == "" ) {
          this.isLocalCityError = "Please enter City";
          this.isLocalCity = false;
        } else {
          this.isLocalCity = true;
        }
        if( this.addresses.localAddress.state == "" ) {
          this.isLocalStateError = "Please select US State";
          this.isLocalState = false;
        } else {
          this.isLocalState = true;
        }
        if( this.addresses.localAddress.zipCode == "" ) {
          this.isLocalZipCodeError = "Please enter Postal Code";
          this.isLocalZipCode = false;
        } else {
          this.isLocalZipCode = true;
        }
        if( this.isLocalAddress1 && this.isLocalCity && this.isLocalState && this.isLocalZipCode ) {
          this.saveAddress();
        } else {
          this.isMessage = false;
          this.message = "Please enter the required details.";
        }

      } else if( this.addresses.businessAddress.isPreferredAddress ) {
        if( this.addresses.businessAddress.company == "" ) {
          this.isBusinessCompanyError = "Please enter Company Employer Name";
          this.isBusinessCompany = false;
        } else {
          this.isBusinessCompany = true;
        }
        if( this.addresses.businessAddress.address1 == "" ) {
          this.isBusinessAddress1Error = "Please enter Street Address";
          this.isBusinessAddress1 = false;
        } else {
          this.isBusinessAddress1 = true;
        }
        if( this.addresses.businessAddress.city == "" ) {
          this.isBusinessCityError = "Please enter City";
          this.isBusinessCity = false;
        } else {
          this.isBusinessCity = true;
        }
        if( this.addresses.businessAddress.country == "U.S.A." && this.addresses.businessAddress.state == "" ) {
          this.isBusinessStateError = "Please select US State";
          this.isBusinessState = false;
        } else {
          this.isBusinessState = true;
        }
/* 2025-03-04 TBH - Province optional on Business address if country is not "U.S.A."
        if( this.addresses.businessAddress.country != "U.S.A." && this.addresses.businessAddress.province == "" ) {
          this.isBusinessProvinceError = "Please enter Province";
          this.isBusinessProvince = false;
        } else {
          this.isBusinessProvince = true;
        }
*/
        if( this.addresses.businessAddress.country == "" ) {
          this.isBusinessCountryError = "Please select Country";
          this.isBusinessCountry = false;
        } else {
          this.isBusinessCountry = true;
        }
        if( this.addresses.businessAddress.zipCode == "" ) {
          this.isBusinessZipCodeError = "Please enter Postal Code";
          this.isBusinessZipCode = false;
        } else {
          this.isBusinessZipCode = true;
        }
        if( this.isBusinessCompany && this.isBusinessCity && this.isBusinessState && this.isBusinessZipCode ) {
          this.saveAddress(); 
        } else {
          this.isMessage = false;
          this.message = "Please enter the required details.";
        }

      } else if( this.addresses.permanentAddress.isPreferredAddress ) {
        if( this.addresses.permanentAddress.address1 == "" ) {
          this.isPermanentAddress1Error = "Please enter Street Address";
          this.isPermanentAddress1 = false;
        } else {
          this.isPermanentAddress1 = true;
        } if( this.addresses.permanentAddress.city == "" ) {
          this.isPermanentCityError = "Please enter City";
          this.isPermanentCity = false;
        } else {
          this.isPermanentCity = true;
        }
        if( this.addresses.permanentAddress.country == "" ) {
          this.isPermanentCountryError = "Please select Country";
          this.isPermanentCountry = false;
        } else {
          this.isPermanentCountry = true;
        }
        if( this.addresses.permanentAddress.zipCode == "" ) {
          this.isPermanentZipCodeError = "Please enter Postal Code";
          this.isPermanentZipCode = false;
        } else {
          this.isPermanentZipCode = true;
        }
        if( this.isPermanentAddress1 && this.isPermanentCity && this.isPermanentCountry && this.isPermanentZipCode ) {
          this.saveAddress(); 
        } else {
          this.isMessage = false;
          this.message = "Please enter the required details.";
        }
      }       
// console.log( 'updateAddressData() - End: ' + this.message );
      this.isSubmitting = false;
    },
        
    init() {
      this.getStates();
    },
  }
}